import React from "react";
import { Boxes } from "lucide-react";

const COLS = [
  { title: "Procurement Models", links: ["SmartContainer™", "CommodityBid™", "RFQ™", "FullContainer™"] },
  { title: "Platform", links: ["Verified Manufacturers™", "FreightIQ™", "Inspection™", "Live Tracking™"] },
  { title: "Company", links: ["About DeMaxtore", "Careers", "Contact", "Trust & Security"] },
];

export default function Footer() {
  return (
    <footer className="border-t border-slate-200 bg-white" data-testid="footer">
      <div className="dm-container py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-10">
          <div className="col-span-2">
            <div className="flex items-center gap-2.5">
              <span className="grid place-items-center h-8 w-8 rounded-lg bg-slate-900">
                <Boxes className="h-4 w-4 text-white" strokeWidth={2} />
              </span>
              <span className="text-[15px] font-bold tracking-tight text-slate-900">DeMaxtore</span>
            </div>
            <p className="mt-4 text-sm text-slate-500 leading-relaxed max-w-xs">
              Intelligent procurement coordination for importers sourcing directly from verified Turkish manufacturers.
            </p>
          </div>
          {COLS.map((col) => (
            <div key={col.title}>
              <h4 className="text-xs font-semibold uppercase tracking-wider text-slate-400">{col.title}</h4>
              <ul className="mt-4 space-y-2.5">
                {col.links.map((l) => (
                  <li key={l}><a href="#top" className="text-sm text-slate-600 hover:text-slate-900 transition-colors">{l}</a></li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="mt-14 pt-8 border-t border-slate-100 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-slate-400">
            © {new Date().getFullYear()} DeMaxtore. SmartContainer™ is a procurement model. DeMaxtore does not buy or sell products.
          </p>
          <div className="flex items-center gap-6">
            <a href="#top" className="text-xs text-slate-400 hover:text-slate-600 transition-colors">Privacy</a>
            <a href="#top" className="text-xs text-slate-400 hover:text-slate-600 transition-colors">Terms</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
